import { Component, OnInit, Input } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { DataService } from 'src/app/planner/services/data.service';
import * as _ from 'lodash';
import { AdvertiserInfoVO } from './../../../interfaces/AdvertiserInfo';
import { PublisherDealType } from 'src/app/planner/enums/PublisherDealType.enum';
import { IButtonProps, ButtonVariant } from '@amobee/component-library';
import { BSData, BSSettings } from 'src/app/common/components/browse-and-select/BrowseAndSelectModel';
import { InventoryFilterService } from 'src/app/planner/services/inventory-filter.service';
import { CurrencyPipe } from '@angular/common';

@Component({
	selector: 'private-deals',
	templateUrl: './private-deals.component.html',
	styleUrls: ['./private-deals.component.scss']
})
export class PrivateDealsComponent implements OnInit {

	@Input() group: any;
	@Input() formArray: FormArray;
	@Input() isNew: boolean;
	@Input() advertiserInfo: AdvertiserInfoVO;

	originalFullPrivateDeals: BSData[] = [];
	currentPrivateDeals: BSData[] = [];
	preSelectedPrivateDeals: BSData[] = [];
	selectedPrivateDeals: BSData[] = [];
	selectionText: string;
	tooltipText: Array<string> = [];
	selectedTableNullStateText: string = 'Select in the table above to add Private Deals';
	open: boolean = false;
	saveButton: IButtonProps = {
		variant: ButtonVariant.PRIMARY,
		label: 'Save',
		onClick: () => {
			this.savePrivateDeals();
		}
	};
	cancelButton: IButtonProps = {
		variant: ButtonVariant.NEUTRAL,
		label: 'Cancel',
		onClick: () => {
			this.cancel();
		}
	};
	settings: BSSettings = {
		views: [
			{
				label: 'Private Deals',
				columns: [
					{
						header: 'Name',
						accessor: (row: any) => {
							return row.name
						},
						subtextAccessor: (row: any) => {
							return 'ID: ' + row.dealId
						}
					},
					{
						header: 'Floor Price',
						width: '100px',
						accessor: (row: any) => {
							return this.currencyPipe.transform(row.price, this.advertiserInfo.currency, 'symbol', '1.2');
						}
					},
					{
						header: 'Inventory Source',
						width: '150px',
						accessor: (row: any) => {
							return row.invSource
						}
					}
				]
			}
		],
		filters: []
	};

	constructor(
		private dataService: DataService,
		private inventoryFilterService: InventoryFilterService,
		private currencyPipe: CurrencyPipe
	) { }

	ngOnInit() {
		if (this.privateDealsControl.disabled) {
			this.saveButton.disabled = true;
		}
		this.updateSelection(true);
		this.dataService.getAvailableTargetDeals(this.advertiserInfo.marketId, this.advertiserInfo.id, 2, [PublisherDealType.UnreservedFixed, PublisherDealType.PrivateAuction], false).then((data: Array<any>) => {
			data.forEach(element => element.id = element.publisherDealId);
			this.originalFullPrivateDeals = data;
			this.currentPrivateDeals = data;
			this.settings.filters = this.inventoryFilterService.getDealFiltersFromData(data, 'privateDeals');
			if (!this.isNew) {
				let selectedDeals = _.map(this.privateDealsControl.value, 'id');
				this.preSelectedPrivateDeals = this.selectedPrivateDeals = data.filter(element => selectedDeals.includes(element.id));
				this.updateSelection();
			}
		});
	}

	onDataChange(d: Array<BSData>) {
		this.selectedPrivateDeals = d;
	}

	onFilterChange(f: any) {
		this.currentPrivateDeals = this.inventoryFilterService.publisherDealFilter(this.originalFullPrivateDeals, f);
	}

	openSidebar() {
		if (!this.isDisabled) {
			this.open = true;
		}
	}

	cancel() {
		// trigger refresh on selected table
		let selectedDeals = _.map(this.privateDealsControl.value, 'id');
		this.preSelectedPrivateDeals = this.originalFullPrivateDeals.filter(element => selectedDeals.includes(element.id));
		this.open = false;
	}

	reset() {
		if (this.preSelectedPrivateDeals.length > 0) {
			this.preSelectedPrivateDeals = this.selectedPrivateDeals = [];
			this.privateDealsControl.patchValue([]);
			this.updateSelection();
		}
		if (!this.privateDealsControl.touched) {
			this.privateDealsControl.markAsTouched();
		}
	}

	savePrivateDeals() {
		this.preSelectedPrivateDeals = this.selectedPrivateDeals;
		this.privateDealsControl.patchValue(
			this.selectedPrivateDeals.map((element: BSData) => {
				return { id: element.id, name: element.name, dealId: element.dealId }
			})
		);
		this.updateSelection();
		if (!this.privateDealsControl.touched) {
			this.privateDealsControl.markAsTouched();
		}
		this.open = false;
	}

	updateSelection(initial: boolean = false) {
		if (initial && this.privateDealsControl.value && this.privateDealsControl.value.length) {
			this.selectionText = "(" + this.privateDealsControl.value.length + ")";
			this.tooltipText = _.map(this.privateDealsControl.value, (item) => item.name);
		} else if (_.size(this.selectedPrivateDeals)) {
			this.selectionText = "(" + this.selectedPrivateDeals.length + ")";
			this.tooltipText = _.map(this.selectedPrivateDeals, (item) => item.name);
		} else {
			this.selectionText = "";
			this.tooltipText = [];
		}
	}

	get privateDealsControl() {
		return this.formArray.controls[this.group].get("deals") as FormControl;
	}

	get isDisabled(): boolean {
		return this.privateDealsControl.disabled;
	}

}
